import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "top-email_n",
  "use": "top-email_n-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"top-email_n\">\n<rect fill=\"none\" width=\"48\" height=\"48\" />\n<path d=\"M40,10.3H8c-0.4,0-0.8,0.3-0.8,0.8v22c0,2.6,2.1,4.8,4.8,4.8h24c2.6,0,4.8-2.1,4.8-4.8V11C40.8,10.6,40.4,10.3,40,10.3z\n\t M37.9,11.8L23.8,26L9.6,11.8H37.9z M36,36.2H12c-1.8,0-3.2-1.5-3.2-3.2V13l14.6,14.6c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0,0,0,0\n\tc0.2,0,0.4-0.1,0.5-0.2l14.9-15.1V33C39.2,34.8,37.8,36.2,36,36.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol